import React from "react";
import TraceroLogo from "../../assets/images/video-thumbnail.png";
import IDocument from "../../models/IDocument";
import {
    Typography,
    Grid,
    makeStyles,
    createStyles,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Tooltip,
    Button,
    Paper
} from "@material-ui/core";
import { Player, BigPlayButton } from "video-react";
import { useAuth } from "../../services/authentication";

import { API_URI } from "../../environmentVariables";
import styled from "styled-components";
import { CloudDownload } from "@material-ui/icons";

const StyledHeader2 = styled(CardHeader)`
    padding-bottom: 0px !important;
`;

const VideoCardActions = styled(CardActions)`
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    margin-top: -35px !important;
    margin-left: 282px !important;
`;

const VideoCardContent = styled(CardContent)`
    padding-top: 0px !important;
    padding-bottom: 0px !important;
`;

const VideoCard = styled(Card)`
    box-shadow: none !important;
`;

const StyledCardHeader = styled(({ ...other }) => <StyledHeader2 {...other} />)`
    & .MuiCardHeader-content {
        flex: 1 1 auto;
        width: auto;
    }
`;

const useStyles = makeStyles(() =>
    createStyles({
        videoContainer: {
            width: "auto",
            margin: 25,
            boxShadow: "none !important"
        },
        videoActions: {
            marginLeft: "305px"
        },
        noVideoText: {
            textAlign: "center",
            paddingTop: "200px"
        }
    })
);

interface IVideosTable {
    documents: IDocument[] | null;
    isLoading: boolean;
    isProcessing: boolean;
}

const VideosTable: React.FC<IVideosTable> = ({ documents }) => {
    const [sortedDocuments, setSortedDocuments] = React.useState<
        IDocument[] | null
    >(documents);

    React.useEffect(() => {
        if (documents !== null) {
            setSortedDocuments(documents.map(x => x));
        }
    }, [documents]);

    const { authState } = useAuth();

    function truncateText(text, length) {
        if (text.length <= length) {
            return text;
        }

        return text.slice(0, length) + "...";
    }

    function getDownloadUrl(document: IDocument) {
        if (document != null) {
            return (
                API_URI +
                `projects/all/${document.projectId}/documents/${document.id}/content?access_token=` +
                authState?.accessToken
            );
        }
    }

    const downloadVideo = (video: IDocument) => {
        const link = document.createElement("a");
        const href: string | undefined = getDownloadUrl(video);

        if (href) {
            link.href = href;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const classes2 = useStyles();
    if (sortedDocuments!.length > 0) {
        return (
            <Grid container spacing={0} direction="row">
                {sortedDocuments!.map(video => (
                    <Grid key={video.id} item md={4}>
                        <Paper className={classes2.videoContainer}>
                            <VideoCard>
                                <VideoCardContent>
                                    <Player
                                        fluid={false}
                                        width={336}
                                        height={184}
                                        playsInline
                                        preload="none"
                                        light={true}
                                        poster={TraceroLogo}
                                        startTime={1}
                                        src={getDownloadUrl(video)}
                                    >
                                        <BigPlayButton position="center" />
                                    </Player>
                                    <StyledCardHeader
                                        title={truncateText(video.title, 25)}
                                        style={{ marginLeft: "-17px" }}
                                        titleTypographyProps={{
                                            noWrap: true,
                                            variant: "h6",
                                            component: "h6"
                                        }}
                                    ></StyledCardHeader>
                                    <VideoCardActions
                                        className={classes2.videoActions}
                                    >
                                        <Button
                                            onClick={() => downloadVideo(video)}
                                        >
                                            <CloudDownload color="primary"></CloudDownload>
                                        </Button>
                                    </VideoCardActions>
                                </VideoCardContent>
                                <VideoCardContent>
                                    <Tooltip
                                        title={video.description ?? video.title}
                                    >
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                            component="p"
                                            noWrap
                                        >
                                            {video.description ?? video.title}
                                        </Typography>
                                    </Tooltip>
                                </VideoCardContent>
                            </VideoCard>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        );
    } else {
        return (
            <Typography
                className={classes2.noVideoText}
                variant="body1"
                color="textSecondary"
                component="p"
                noWrap
            >
                {
                    "No 4D visualisation reporting currently available for this project."
                }
            </Typography>
        );
    }
};

export default VideosTable;
